import { useEffect } from 'react';
import { FamilyMember, useProfileImage } from 'all-in-one-shared-api';
import { Radio } from 'antd';
import styled from 'styled-components';

import { useKeycloakReady } from 'hooks/useKeycloakReady';

import { Avatar } from 'components/avatar';

const FullNameText = styled.div`
  display: inline;
  margin-left: 8px;
`;

export const MemberRadioItem = ({ memberType, firstName, lastName }: FamilyMember): JSX.Element => {
  const { token, ready } = useKeycloakReady();

  const { shouldFetch: fetchProfileImage, data: profileImageData } = useProfileImage(
    { name: 'useProfileImage', memberType },
    token ?? '',
    memberType,
    {
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    fetchProfileImage(ready && !!memberType);
  }, [ready, memberType, fetchProfileImage]);

  const profileImage =
    !!profileImageData && profileImageData.length > 0
      ? profileImageData.find((profileImage) => profileImage.memberType === memberType)
      : undefined;
  const avatarUrl = profileImage ? profileImage.pictureUrl : '';

  return (
    <Radio name="patientMemberType" value={memberType}>
      <Avatar avatarUrl={avatarUrl} />
      <FullNameText>
        {firstName} {lastName}
      </FullNameText>
    </Radio>
  );
};
